import { H3 } from '@zooplus/ui-components';
import { useTranslation } from '../../hooks/use-translations';
import styles from './DidYouKnow.module.scss';
import React from 'react';
import { DidYouKnowSection } from './did-you-know-section/DidYouKnowSection';

export type DidYouKnowProps = {};

export const DidYouKnow = ({}: DidYouKnowProps) => {
  const { t } = useTranslation();
  return (
    <section>
      <H3 className={styles.title}>{t('did-you-know.title')}</H3>
      <div className={styles.didYouKnow}>
        <DidYouKnowSection sectionNumber={1} numberCards={6} />
        <DidYouKnowSection sectionNumber={2} numberCards={3} />
        <DidYouKnowSection sectionNumber={3} numberCards={3} />
      </div>
    </section>
  );
};
